// extracted by mini-css-extract-plugin
export default {"loading":"SingleTextLoader_loading__-mYOV","salmon":"SingleTextLoader_salmon__pPgrP","gray":"SingleTextLoader_gray__inw7y"};